import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Checkbox } from '../../../Checkbox';
import { SelectMenuContext } from '../../context';
import { removePlaceholder, SelectOptionTypes } from '../../helper';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
function SelectAll(props) {
  const {
    options,
    onSelect,
    selectAllLabel,
    unSelectAllLabel
  } = props;
  const {
    placeHolder,
    selectedValues,
    selectMenuSelectAllRef
  } = useContext(SelectMenuContext);
  const totalSelectedValues = removePlaceholder(selectedValues, placeHolder);
  const totalAvailableOptions = options.reduce((acc, curr) => {
    if (curr.type === SelectOptionTypes.GROUP_LIST) {
      const {
        items = []
      } = curr;
      items.forEach(item => {
        if (!item.disabled) {
          acc.push({
            ...item
          });
        }
      });
    } else {
      if (!curr.disabled) {
        acc.push({
          ...curr
        });
      }
    }
    return acc;
  }, []);
  const selectedOptions = totalAvailableOptions.filter(option => {
    return totalSelectedValues.some(value => option.key === value.key && option.value === value.value);
  });
  const noOfAvailableOptions = totalAvailableOptions.length;
  const noOfSelectedOptions = selectedOptions.length;
  const isChecked = selectedOptions.length > 0;
  const variant = noOfAvailableOptions === noOfSelectedOptions ? 'positive' : 'undetermined';
  const handleSelectAll = event => {
    event.stopPropagation();
    if (isChecked) {
      const otherSelectedOptions = totalSelectedValues.filter(value => !totalAvailableOptions.some(option => option.key === value.key && option.value === value.value));
      fireChangeEvent([...otherSelectedOptions], event);
    } else {
      const checkedOptions = options.reduce((result, current) => {
        if (current.type === SelectOptionTypes.GROUP_LIST) {
          const {
            items = []
          } = current;
          items.forEach(item => {
            if (!item.disabled) {
              result.push({
                ...item
              });
            }
          });
        } else {
          const {
            disabled
          } = current || {};
          if (!disabled) {
            result.push({
              ...current
            });
          }
        }
        return result;
      }, []);
      fireChangeEvent([...selectedValues, ...checkedOptions], event);
    }
  };
  const fireChangeEvent = (filteredValues, event) => {
    if (onSelect) {
      onSelect(filteredValues, event);
    }
  };
  const selectAllText = `${isChecked ? unSelectAllLabel : selectAllLabel} (${noOfSelectedOptions}/${noOfAvailableOptions})`;
  const selectAllClass = classNames({
    [styles['sib-selectmenu-multi-option']]: true,
    [styles['select-all']]: true,
    [styles['select-' + variant]]: isChecked
  });
  return /*#__PURE__*/React.createElement("li", {
    ref: selectMenuSelectAllRef,
    className: selectAllClass,
    role: "option",
    "aria-selected": isChecked ? 'true' : 'false'
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-selectmenu-multi-option__content'],
    title: selectAllText,
    onClick: event => handleSelectAll(event),
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['primary-info']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    ellipsis: true,
    label: selectAllText,
    labelClassName: styles['sib-checkbox-title-custom'],
    identifier: "sibCheckbox_selectAll",
    checked: isChecked,
    variant: variant,
    onChange: event => {
      event.stopPropagation();
    },
    onClick: e => {
      e.stopPropagation();
    },
    onKeyDown: event => {
      if (event.which === 13 || event.which === 32) {
        event.stopPropagation();
        handleSelectAll(event);
      }
    }
  }))));
}
SelectAll.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    value: PropTypes.string,
    helpText: PropTypes.string,
    addtionalInfo: PropTypes.func,
    items: PropTypes.array
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectAllLabel: PropTypes.string.isRequired,
  unSelectAllLabel: PropTypes.string.isRequired
};
export default SelectAll;